<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="loaded ? pageTitle : ''"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (!loaded && errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-card>
        <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
          <div>
            <tidy-text
              [header]="job?.serviceName | titlecase" /><br>
            <tidy-text
              [body]="addressName" />
          </div>
          <div>
            <tidy-text
              [header]="(job?.date | parseDateTime: 'ddd') + ' ' + (job?.date | parseDateTime: 'MMM d')" /><br>
            <tidy-text
              [body]="job?.startTime | parseDateTime: 'h:mma'" />
          </div>
        </tidy-row>
        @if (job?.proFirstName) {
          <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding extra-top-padding">
            <tidy-initials-icon
              [fullName]="job?.proFirstName" />
            <tidy-text
              [body]="job?.proFirstName" />
            <tidy-text
              [body]="job?.proPhone | telephone" />
          </tidy-row>
        }
        <tidy-row class="extra-bottom-padding">
          <tidy-divider />
        </tidy-row>
        <tidy-row>
          @if (!isPastJobLink) {
            <tidy-text
              [body]="job?.proFirstName + (' can see this job in the <u>TIDY Pro App</u> if they use their email on file. You can also share a link to the job with them:' | translate)" />
          }
          @if (isPastJobLink) {
            <tidy-text
              [body]="'You can share this link to the job:'" />
          }
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="jobLink" />
          @if (copied) {
            <tidy-text
              style="margin-left:5px"
              [helper]="'Copied'" />
          }
        </tidy-row>
        <tidy-button
          [action]="boundCopyLink"
          [text]="'Copy Job Link'"
          class="primary" />
        <tidy-row class="extra-top-padding" [align]="'center'">
          <tidy-text
            class="link"
            [actionBody]="'Learn More'"
            (action)="learnMore()" /><span>&nbsp;</span>
          <tidy-text
            [body]="'about job links'" />
        </tidy-row>
      </tidy-card>
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
